export default __webpack_public_path__ + "static/media/data_science.6c372e36.svg";